































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LoginModule from '~/store/login';
import SessionModule from '~/store/session';

@Component<Header>({})
export default class Header extends Vue {
    @Resolve
    session!: SessionModule;

    get isDashboardPage(){
        return this.$route.name === 'dashboard'
    }

   handleHomeClick() {
        this.$router.push({ path: '/' }).catch(error => {});
    }

}
